import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { login } from '../utils/auth';

import './auth.css';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from || '/';

  function onSubmit(e) {
    e.preventDefault();
    const res = login({ username: username.trim(), password });
    if (!res.ok) {
      setError(res.error);
      return;
    }
    navigate(from);
  }

  return (
    <div className="auth-wrap">
      <h1>登录</h1>
      <form className="editor" onSubmit={onSubmit}>
        <input placeholder="用户名" value={username} onChange={e => setUsername(e.target.value)} />
        <input placeholder="密码" type="password" value={password} onChange={e => setPassword(e.target.value)} />
        {error && <div className="error">{error}</div>}
        <div className="auth-actions">
          <div />
          <div className="editor-actions">
            <button className="btn" type="submit">登录</button>
          </div>
        </div>
      </form>
      <div style={{ marginTop: 12, textAlign: 'center' }}>
        没有账号？ <Link to="/register">注册</Link>
      </div>
    </div>
  );
}
